module.exports = __webpack_public_path__ + "static/media/Hm2.a89009b4.png";